<template>
    <div>
      <h2>系列信息</h2>
      
      <!-- 添加/编辑表单 -->
      <!-- <button @click="openDialog(null)">新增数据</button> -->
       <div style="text-align: left;margin-top: 10px;margin-bottom: 5px;">
        <el-button type="primary" @click="openDialog(null)" round >新增数据</el-button>
    </div>
   
      <!--列表 -->
      <el-table
    :data="dataList"
    style="width: 100%;"
    >
    <el-table-column
      prop="name"
      label="主编码"
      width="180">
    </el-table-column>
    <el-table-column
      prop="description"
      label="描述"
      width="180">
    </el-table-column>
    <el-table-column
      prop="date"
      label="日期"
      width="180">
    </el-table-column>
    <el-table-column
      prop="date"
      label="日期"
      width="180">
    </el-table-column>
    <el-table-column label="图片" width="180">
      <template #default="scope">
        <img v-if="scope.row.url" :src="scope.row.url"  style="width: 100px; max-height: 50px;">
      </template>
    </el-table-column>
    <el-table-column
      prop="remark"
      label="备注">
    </el-table-column>
    <el-table-column
      label="操作">
      <template slot-scope="scope">
        <el-button size="mini" @click="openDialog(scope.row)">Edit</el-button>
        <el-button size="mini" type="danger" @click="deleteProduct(scope.row.id)">Delete</el-button>
      </template>
    </el-table-column>
        </el-table>

        <!-- 弹窗 -->
        <el-dialog
        title="提示"
        :visible.sync="isDialogVisible"
        width="30%">
        <el-form :model="currentData">
          <el-form-item label="名称" :label-width="formLabelWidth">
            <el-input placeholder="请输入名称" v-model="currentData.name" style="display: inline;margin-left: 5px; height: 200px;" 
                    clearable required>
                    </el-input>
        </el-form-item>
      <el-form-item label="描述" :label-width="formLabelWidth">
        <el-input placeholder="请输入描述" v-model="currentData.description" style="display: inline;margin-left: 5px; height: 200px;" 
                clearable required>
                </el-input>
    </el-form-item>
    <el-form-item label="备注" :label-width="formLabelWidth">
      <el-input  v-model="currentData.remark" style="display: inline;margin-left: 5px; height: 200px;" 
              clearable required>
              </el-input>
  </el-form-item>
          <el-form-item label="图片" :label-width="formLabelWidth">
            <el-upload
              class="avatar-uploader"
              action="" 
              :before-upload="beforeUpload"
              :show-file-list="false"
              :on-change="handleFileChange"
            :file-list="fileList"  
              >
              <img v-if="isImage" :src="currentData.url" class="avatar"  />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          </el-form-item>
          
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="saveProduct">确 定</el-button>
          <el-button @click="isDialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>
     <!-- <div v-if="isDialogVisible" class="dialog-mask">
        <div class="dialog-content">
            <h3 style="margin-bottom: 20px;">{{ isEditMode ? '修改' : '新增' }}</h3>
            <div class="form-group">
                <label style="display: inline;">名称</label>
                <el-input placeholder="请输入名称" v-model="currentData.name" style="display: inline;margin-left: 5px; " 
                 clearable required>
                </el-input>
            </div>
            <div class="form-group">
                <label style="display: inline;">描述</label>
                <el-input placeholder="请输入描述" v-model="currentData.description" style="display: inline;margin-left: 5px; "  clearable required></el-input>
            </div>
           
            <div class="form-group">
                <label style="display: inline;">备注</label>
                <el-input v-model="currentData.remark" style="display: inline;margin-left: 5px; " ></el-input>
            </div>
            <div>
              <label for="">图片</label>
              <el-upload
                class="avatar-uploader"
                action="" 
                :before-upload="beforeUpload"
                :show-file-list="true"
                :on-change="handleFileChange"
              :file-list="fileList"  
                >
                
                <i  class="el-icon-plus avatar-uploader-icon" ></i>
            </el-upload>
            </div>
            <div class="button-group">
                <el-button size="mini" round @click="saveProduct">确认</el-button>
                <el-button size="mini" round @click="closeDialog">取消</el-button>
                
            </div>
        </div>
     </div> -->
    </div>
</template>
   
  <script>
//   import axios from 'axios';
  
import {getProductMainCode,addProductMainCode,delProductMainCode} from "@/api/rbac/product";
   
  export default {
    data() {
      return {
        dataList: [],
        currentData: { id: 0, name: '',description:'',date:new Date(),remark:'',sort:0,url:''},
        isDialogVisible: false,
        isEditMode: false,
        fileList:[],
        isImage: false,
        isVideo: false,
        formLabelWidth:'80px',
        mainUrl:'',
      };
    },
  created() {
       this.loadDataList();
    },
    methods: {
      async loadDataList() {
        try {
            getProductMainCode({strType:'MainCode'}).then(res=>{
                if (res.data.length==0) {
                    // console.log(this.dataList)
                }
                else{
                    this.dataList=res.data;
                    this.dataList.forEach((item)=>{
                      if (item.url!=null) {
                        item.url='../../../assets/img/MainCode/'+item.url
                      }
                    })
                }
            })
        } catch (error) {
          console.error('获取失败:', error);
        }
      },
   
      async saveProduct() {
        if (!String(this.currentData.name).trim()) {
            alert("名称为空")
        }
        else if(!String(this.currentData.description).trim())
        {
            alert("描述为空")
        }
        else{
            try {
              const formData = new FormData();
              this.fileList.forEach((file) => {
              formData.append('files[]', file.raw);
              });
              formData.append("strType","MainCode")
              formData.append("ID",this.currentData.id)
              formData.append("name",this.currentData.name)
              formData.append("description",this.currentData.description)
              formData.append("remark",this.currentData.remark)
                addProductMainCode(formData).then(res=>{
                    if (res.data=='ok') {
                        this.currentData = { id: 0, name: '',description:'',date:new Date(),remark:'',sort:0,url:''};
                        this.loadDataList();
                        this.isDialogVisible=false;
                    }
                })
            } catch (error) {
            console.error('保存失败:', error);
            }
        }
       
      },
   
      editProduct(product) {
        this.currentData = { ...product };
      },
   
      async deleteProduct(id) {
        try {
        //   await axios.delete(`http://localhost:5432/api/v1/userinfo/DeleteProduct/${id}`);
        delProductMainCode(id).then(res=>{
            if (res.data=="ok") {
                alert(id)
                this.loadDataList();
            }
        })
          
          this.currentData = { id: 0, name: '',description:'',date:new Date(),remark:'',sort:0,url:''};
        } catch (error) {
          console.error('删除失败:', error);
        }
      },
      
      openDialog(item) {
      this.isDialogVisible = true
      this.isEditMode = !!item
      
      // 深拷贝避免直接修改原数据
      if (item) {
        this.currentData = { ...item }
      } else {
        this.currentData = { id: 0, name: '',description:'',date:new Date(),remark:'',sort:0,url:''};
      }
      if (this.currentData.url==undefined||this.currentData.url.length==0) {
				this.isImage=false;
			}
			else{
				this.isImage=true;
			}
    },
 
    closeDialog() {
      this.isDialogVisible = false
    },
 
    beforeUpload(file) {
            console.log(file)
            return false; // 阻止自动上传
        },
        handleFileChange(file, fileList) {
            console.log('fileList',fileList)
            this.isImage=true;
            this.fileList=[];
            this.fileList.push(file)
            if (file.status === 'ready') {
                // 当文件状态为 ready 时，生成预览 URL
                const reader = new FileReader();
                reader.onload = (e) => {
                this.currentData.url = e.target.result;
                };
                reader.readAsDataURL(file.raw);
            }
        },
        hoverFileChange(file, fileList) {
            console.log('fileList',fileList)
            
            this.hoverList=[];
            this.hoverList.push(file)
            if (file.status === 'ready') {
                // 当文件状态为 ready 时，生成预览 URL
                const reader = new FileReader();
                reader.onload = (e) => {
                this.hoverUrl = e.target.result;
                };
                reader.readAsDataURL(file.raw);
            }
        },
    },
  };
  </script>
<style>
    .dialog-mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
    }
     
    .dialog-content {
      background: #545C64;
      padding: 20px;
      border-radius: 8px;
      min-width: 350px;
      margin-top: 10px;
    }
     
    .form-group {
      margin-bottom: 15px;
      text-align: left;
    }
     
    .form-group label {
      display: block;
      margin-bottom: 5px;
    }
    .form-group input {
     width: 260px;
    }
    .button-group {
      margin-top: 15px;
      text-align: right;
    }
     
    .button-group button {
      margin-left: 10px;
    }
    </style>